import { jwtDecode } from 'jwt-decode';
import { centralizedLoginSDK } from './CentralizedLoginSDK';

//AuthStore saves userData (from jwt from BE) in a cookie
//These methods are for setting, updating, and pulling info from the cookie

//full user data including access token
export const getUser = async () => centralizedLoginSDK().getUserFromCookie();

//just the accessToken in the userData jwt
export const getAccessToken = async () => {
  const user = await getUser();

  return user?.accessToken;
};

const getJwt = async () => {
  try {
    const accessToken = await getAccessToken();

    if (!accessToken) {
      return {};
    }

    return jwtDecode(accessToken);
  } catch {
    return {};
  }
};

export const isNonAnonymousUser = async () => {
  const jwt = await getJwt();

  return !!jwt?.atype && jwt.atype !== 'anonymous' && jwt.utype !== 'mvpd';
};

export const getUserMvpdId = async () => {
  const jwt = await getJwt();

  return jwt?.mvpdid;
};

export const isAnonymousUser = async () => {
  const jwt = await getJwt();

  return !!jwt?.atype && (jwt.atype === 'anonymous' || jwt.utype === 'mvpd');
};

export const isMvpdUser = async () => {
  return (await isAnonymousUser()) && !!(await getUserMvpdId());
};
